import React, { useState } from 'react';
import { BsFillPencilFill, BsFillTrash3Fill } from 'react-icons/bs';
import { IoEyeOutline } from 'react-icons/io5';
import { FaEyeSlash } from 'react-icons/fa6';

function RoleComponent({ role, onEditRole, onDeleteRole }) {
  const [check, setCheck] = useState(false);
  let count = 1;
  return (
    <>
      <div className="h-min-[20vh] w-[90%] gap-2 border border-black flex flex-col">
        <div
          // onClick={() => setCheck(!check)}
          className="h-[5vh] w-[100%] flex justify-around items-center border border-b-black"
        >
          <div className="flex flex-row items-center">
            <span
              style={{
                height: '20px',
                minWidth: '80px',
                borderRadius: '20px',
                backgroundColor: 'red',
                color: 'white',
                // textTransform: "capitalize",
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                margin: '0 5px',
                fontSize: '10px',
                fontWeight: 'bold',
                cursor: 'pointer',
              }}
            >
              {role?.name}
            </span>

            <span onClick={() => setCheck(!check)}>
              {check ? (
                <FaEyeSlash style={{ color: 'red', cursor: 'pointer' }} />
              ) : (
                <IoEyeOutline style={{ color: 'red', cursor: 'pointer' }} />
              )}
            </span>
          </div>

          <div
            style={{
              width: '50%',
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '10px',
            }}
          >
            <BsFillPencilFill
              style={{ cursor: 'pointer' }}
              onClick={() => onEditRole(role._id)}
            />
            <BsFillTrash3Fill
              style={{ cursor: 'pointer' }}
              onClick={() => onDeleteRole(role._id)}
            />
          </div>
        </div>
        {check && (
          <div className="h-[min-15vh] w-[100%] flex flex-col border border-t-black">
            <div className="h-[5vh] w-[100%] flex justify-around border border-b-black">
              <div className="h-[100%] w-[50%] flex justify-center items-center border border-r-black font-bold">
                Sr.#
              </div>
              <div className="h-[100%] w-[50%] flex justify-center items-center font-bold">
                Procedure Name
              </div>
            </div>

            {role?.procedures?.map((item, index) => {
              if (
                item?.procedure?.name &&
                item?.procedure?.name.trim() !== ''
              ) {
                return (
                  <div
                    key={index}
                    className="h-[5vh] w-[100%] flex justify-around border border-b-black"
                  >
                    <div className="h-[100%] w-[50%] flex justify-center items-center border border-r-black">
                      {count++}
                    </div>
                    <div className="h-[100%] w-[50%] flex justify-center items-center">
                      {item.procedure.name}
                    </div>
                  </div>
                );
              }

              return null;
            })}
          </div>
        )}
      </div>
    </>
  );
}

export default RoleComponent;
